import styled from "styled-components";

const StyledMessagesByHourAndDay = styled.div`
    box-sizing: border-box;
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;
    gap: 1rem;

    overflow-y: auto;

    .filters {
        display: flex;
        gap: 0.5rem;

        >div:nth-child(2) {
            width: 25rem;
            display: flex;
            flex-direction: column;
            gap: 0.5rem;

            align-items: end;
        }
    }
`;

export default StyledMessagesByHourAndDay;